export default "__VITE_ASSET__63mDmkR1__"